export default __webpack_public_path__ + "static/media/github.2d7f74a5.svg";